import * as R from 'ramda'
import * as React from 'react'

import { useQuery } from '@ngb-frontend/shared/context'
import {
  getMileageStepDataFromBooking,
  useVehicle,
} from '@ngb-frontend/shared/utils'

import { MileageForm } from '../../forms/MileageForm/MileageForm'

import type { MileageFormValues, StepProps } from '@ngb-frontend/shared/types'

const MileageStep: React.FC<StepProps<MileageFormValues>> = ({
  onNextStep,
  onUpdateStep,
  stepData,
  booking,
}) => {
  const query = useQuery()
  const { data: vehicle } = useVehicle(query)

  const initialValuesRef = React.useRef<MileageFormValues | undefined>(
    hasMileageFormValues(stepData)
      ? { mileage: stepData.mileage }
      : booking
      ? getMileageStepDataFromBooking(booking)
      : vehicle?.mostRecentMileage
      ? { mileage: vehicle?.mostRecentMileage }
      : undefined,
  )

  const handleSubmit = React.useCallback(
    (values: MileageFormValues) => {
      onUpdateStep(values)

      onNextStep()
    },
    [onNextStep, onUpdateStep],
  )

  return (
    <MileageForm
      onSubmit={handleSubmit}
      initialValues={initialValuesRef.current}
      vehicleName={[vehicle?.make, vehicle?.model].filter(Boolean).join(' ')}
      licensePlate={vehicle?.licensePlate || query?.licensePlate}
    />
  )
}

export const hasMileageFormValues = (x: unknown): x is MileageFormValues =>
  R.allPass([R.pipe(R.prop('mileage'), R.is(Number))])(x)

export default MileageStep
